import React, { useState } from 'react';
import { Search, Edit3, Share2, Trash2, Heart, X, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function AllNotes({ notes, deleteNote, toggleWishlist }) {
  const [q, setQ] = useState('');
  const [confirmDeleteId, setConfirmDeleteId] = useState(null); // Track which note is being deleted
  const nav = useNavigate();
  
  const filtered = notes.filter(n => 
    n.title.toLowerCase().includes(q.toLowerCase()) || 
    n.content.toLowerCase().includes(q.toLowerCase())
  );

  // Mobile-safe delete: First tap shows "Confirm", second tap deletes
  const triggerDelete = (id) => {
    if (confirmDeleteId === id) {
      deleteNote(id);
      setConfirmDeleteId(null);
    } else {
      setConfirmDeleteId(id);
      // Automatically reset if user doesn't confirm in 3 seconds
      setTimeout(() => setConfirmDeleteId(null), 3000);
    }
  };

  return (
    <div className="animate-in fade-in duration-500 pb-20">
      {/* Search Bar */}
      <div className="relative mb-8">
        <Search className="absolute left-4 top-4 text-gray-300" size={20}/>
        <input 
          className="w-full bg-white border shadow-sm p-4 pl-12 pr-12 rounded-2xl outline-none focus:ring-2 focus:ring-indigo-500" 
          placeholder="Search your notes..." 
          value={q} 
          onChange={e => setQ(e.target.value)} 
          type="text"
        />
        {q && (
          <button onClick={() => setQ('')} className="absolute right-4 top-4 text-gray-300 p-1">
            <X size={20} />
          </button>
        )}
      </div>

      <div className="grid gap-4">
        {filtered.length > 0 ? filtered.map(n => (
          <div key={n.id} className="bg-white p-6 rounded-[2rem] border border-gray-100 shadow-sm relative transition-all active:scale-[0.98]">
            
            {/* Wishlist Heart */}
            <button 
              onClick={() => toggleWishlist(n.id)}
              className="absolute top-6 right-6 p-2 rounded-full active:scale-125 transition-transform"
            >
              <Heart size={22} className={n.isWishlisted ? "fill-red-500 text-red-500" : "text-gray-200"} />
            </button>

            <div className="mb-2 pr-10">
              <h3 className="font-bold text-xl text-gray-800">{n.title}</h3>
              <span className="text-[10px] font-black text-indigo-400 bg-indigo-50 px-2 py-1 rounded-lg uppercase">
                {n.date}
              </span>
            </div>
            
            <p className="text-gray-500 line-clamp-3 mb-6 text-sm leading-relaxed">{n.content}</p>
            
            <div className="flex gap-2 pt-4 border-t border-gray-50">
              <button 
                onClick={() => nav('/editor', {state: {editNote: n}})} 
                className="flex-1 bg-indigo-50 text-indigo-600 py-3 rounded-xl flex justify-center items-center gap-2 font-bold text-xs"
              >
                <Edit3 size={14}/> EDIT
              </button>
              
              <button 
                onClick={() => window.location.href = `mailto:?subject=${encodeURIComponent(n.title)}&body=${encodeURIComponent(n.content)}`} 
                className="flex-1 bg-slate-50 text-gray-600 py-3 rounded-xl flex justify-center items-center gap-2 font-bold text-xs"
              >
                <Share2 size={14}/> SHARE
              </button>
              
              {/* MOBILE-SAFE DELETE BUTTON */}
              <button 
                onClick={() => triggerDelete(n.id)} 
                className={`flex-1 py-3 rounded-xl flex justify-center items-center gap-2 font-black text-xs transition-all duration-300 ${
                  confirmDeleteId === n.id 
                  ? "bg-red-500 text-white" 
                  : "bg-red-50 text-red-400"
                }`}
              >
                {confirmDeleteId === n.id ? (
                  <>CONFIRM?</>
                ) : (
                  <Trash2 size={18}/>
                )}
              </button>
            </div>
          </div>
        )) : (
          <div className="text-center py-20 text-gray-300 italic">No notes found.</div>
        )}
      </div>
    </div>
  );
}